
import Vue from "vue"
import { address } from "thor-devkit"
import { genesisIdToNetwork } from '../utils'

export default Vue.extend({
    props: {
        address: String,
        abbr: Boolean,
        icon: Boolean,
        noLink: Boolean
    },
    asyncComputed: {
        async vetName(): Promise<string | null> {
            if (genesisIdToNetwork(this.$connex.thor.genesis.id) !== 'main') {
                return null
            }
            try {               
                const { decoded: { names } }  = await this.$connex.thor
                    .account(vetResolverUtilsAddress)
                    .method(getNamesJsonAbi)
                    .call([this.address])

                return names[0] || null
            } catch {
                return null
            }
        }
    },
    computed: {
        isValid(): boolean {
            return address.test(this.address);
        }
    }
})

const vetResolverUtilsAddress = '0xA11413086e163e41901bb81fdc5617c975Fa5a1A'
const getNamesJsonAbi = {
  "inputs": [
    {
      "internalType": "address[]",
      "name": "addresses",
      "type": "address[]"
    }
  ],
  "name": "getNames",
  "outputs": [
    {
      "internalType": "string[]",
      "name": "names",
      "type": "string[]"
    }
  ],
  "stateMutability": "view",
  "type": "function"
}

